module.exports = __webpack_public_path__ + "assets/img_vegan.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_vegan.png
 ** module id = 137
 ** module chunks = 1
 **/